import { render, staticRenderFns } from "./VideoReviewClientView.vue?vue&type=template&id=1536966a&scoped=true&"
import script from "./VideoReviewClientView.vue?vue&type=script&lang=js&"
export * from "./VideoReviewClientView.vue?vue&type=script&lang=js&"
import style0 from "./VideoReviewClientView.vue?vue&type=style&index=0&id=1536966a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536966a",
  null
  
)

export default component.exports